import {getTools} from "../services";
import {addTools} from "../store/actions";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {filterByLanguages} from "../utils/filterByLanguages";
import {filterByTags} from "../utils/filterByTags";

interface Props {
    dispatch: Function
}

export const useGetTools = ({dispatch}: Props) => {
    const {tools} = getTools()

    // @ts-ignore
    const filteredLanguages = useSelector((state) => state.filters.languages)
    // @ts-ignore
    const filteredTags = useSelector((state) => state.filters.tags)

    useEffect(() => {
        const byLanguage = filterByLanguages({languages: filteredLanguages, items: tools})
        const toolsToDisplay = filterByTags({tags: filteredTags, items: byLanguage})
        dispatch(addTools({tools: toolsToDisplay}))
    }, [dispatch, tools, filteredLanguages, filteredTags])
}